@let isCustomDeleted = isDisabled() && getCustomValueState('id');

<mat-expansion-panel
  class="cta-expansion-panel"
  [class.analytics-mode-panel]="analyticsMode()"
  [class.view-mode]="isViewMode()"
  [disabled]="isCustomDeleted || analyticsMode()"
  [expanded]="(isPanelExpanded() && !isCustomDeleted) || analyticsMode()"
  [hideToggle]="analyticsMode()"
  (expandedChange)="onPanelExpandedChange($event)"
>
  <mat-expansion-panel-header class="deliverable-flow-expansion-panel-header">
    <mat-panel-title>
      <div class="flex flex-1 justify-between items-center">
        <app-editable-title
          fontClasses="font-bold"
          [class.text-sm]="!analyticsMode()"
          [icon]="form().invalid ? 'icons/circle-x.svg' : 'icons/circle-check.svg'"
          [iconColor]="form().invalid ? 'var(--shikenso-error-bright)' : 'var(--shikenso-pink-base)'"
          [iconSize]="16"
          [subtitle]="'pages.campaignForm.ctaDialog.ctaDetails.deliverables.chatbotDeliverable.subtitle' | translate"
          [control]="name"
          [isViewMode]="isViewMode()"
          [disabled]="isCustomDeleted"
          [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
          [infoTooltip]="'pages.campaignForm.ctaDialog.ctaDetails.deliverables.descriptions.chatBot' | translate"
          [creatorBriefingMode]="creatorBriefingMode()"
          [showRequiredBadge]="showRequiredBadge()"
        />

        @if (!isViewMode()) {
          <div class="flex items-center gap-7">
            <app-deliverable-advanced-button
              [platformFeature]="platformFeature()"
              [deliverableType]="form().value.type"
              [isOpen]="showAdvancedSettings()"
              (toggled)="onToggleAdvancedSettings()"
            />

            <div class="flex items-center">
              @if (isCustomMode() && !form().value.exclusiveTo) {
                <app-custom-remove-button
                  [checked]="!getCustomValueState('id')"
                  (checkboxStateChanged)="onDeleteCheckboxChange('id', $event)"
                  #deleteParentButton
                />
              } @else {
                <button
                  mat-icon-button
                  class="mat-secondary-transparent-button-color"
                  (click)="onDeleteClick(form().value.exclusiveTo)"
                >
                  <app-icon src="/icons/trash.svg" alt="delete" [size]="16" />
                </button>
              }
            </div>
          </div>
        }
      </div>
    </mat-panel-title>

    @if (isCustomDeleted) {
      <svg
        class="absolute top-1/2 -translate-y-1/2 right-1 opacity-[24%] w-6 h-6 mt-[1px]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"></path>
      </svg>
    }
  </mat-expansion-panel-header>

  <div class="flex flex-1 gap-3" [formGroup]="form()">
    <div class="flex flex-[0.5]">
      <mat-form-field
        class="w-full"
        [class.custom-value-border]="isCustomMode() && (getCustomValueState('interval') || form().value.exclusiveTo)"
      >
        <mat-label>
          {{ 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.chatbotDeliverable.interval' | translate }}
        </mat-label>
        <input matInput type="text" formControlName="interval" numberOnly />
        <div matSuffix class="flex items-center gap-1">
          <span class="text-[10px]">{{ 'shared.timeSuffixLong.minutes' | translate }}</span>

          @if (isCustomMode() && !isViewMode() && getCustomValueState('interval') && !form().value.exclusiveTo) {
            <button
              mat-icon-button
              type="button"
              class="mat-secondary-transparent-button-color"
              [disabled]="isCustomDeleted"
              (click)="onRevertToGlobalClick('interval')"
            >
              <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
            </button>
          }

          @if (statusInterval() && isViewMode()) {
            <app-status-badge [status]="statusInterval()!" colorScheme="deliverable" />
          }
        </div>
        <mat-error [control]="form().get('interval')" />
      </mat-form-field>
    </div>

    <div class="flex flex-[0.5]">
      <mat-form-field
        class="w-full"
        matTooltipPosition="above"
        [matTooltip]="isViewMode() ? form().get('text')?.value : ''"
        [class.custom-value-border]="isCustomMode() && (getCustomValueState('text') || form().value.exclusiveTo)"
      >
        <mat-label>
          {{ 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.chatbotDeliverable.text' | translate }}
        </mat-label>
        <input
          matInput
          formControlName="text"
          [placeholder]="
            'pages.campaignForm.ctaDialog.ctaDetails.deliverables.chatbotDeliverable.placeholder' | translate
          "
        />

        @if (isCustomMode() && !isViewMode() && getCustomValueState('text') && !form().value.exclusiveTo) {
          <span matSuffix>
            <button
              mat-icon-button
              type="button"
              class="mat-secondary-transparent-button-color"
              [disabled]="isCustomDeleted"
              (click)="onRevertToGlobalClick('text')"
            >
              <app-icon src="/icons/rotate-360.svg" alt="info" class="w-4 h-4" />
            </button>
          </span>
        }

        @if (statusText() && isViewMode()) {
          <span matSuffix>
            <app-status-badge [status]="statusText()!" colorScheme="deliverable" />
          </span>
        }
        <mat-error [control]="form().get('text')" />
      </mat-form-field>
    </div>
  </div>

  @if (showAdvancedSettings() && !isViewMode()) {
    <div class="pl-3 mt-4">
      <app-deliverable-advanced-settings-section
        [form]="form()"
        [platformFeature]="platformFeature()"
        [deliverableType]="form().value.type"
        [isCustomMode]="isCustomMode()"
        [creatorId]="creatorId()"
      />
    </div>
  }
</mat-expansion-panel>
